export const CREATOR = "Demo User";

export const ROLES = [
  "Annahme",
  "Werkstatt",
  "Spenglerei",
  "Fahrzeugaufbereitung",
  "Leihwagen",
  "Rechnung",
  "Übergabe",
];

export const MASKS = [
  "Werkstättenleitung",
  "Management",
  "Verkauf",
  "Tagesboard",
];

export const PRIO_WEIGHT = {
  urgent: 4,
  high: 3,
  normal: 2,
  low: 1,
};

export const WORK_STATUS = {
  NEW: "NEW",
  IN_WORK: "IN_WORK",
  BLOCKED: "BLOCKED",
  DONE: "DONE",
  INVOICED: "INVOICED",
  DELIVERED: "DELIVERED",
  CANCELLED: "CANCELLED",
};

export const WORK_STATUS_LABELS = {
  NEW: "Neu",
  IN_WORK: "In Arbeit",
  BLOCKED: "Blockiert",
  DONE: "Technisch fertig",
  INVOICED: "Abgerechnet",
  DELIVERED: "Übergeben",
  CANCELLED: "Abgebrochen",
};

export const DAMAGE_CATEGORIES = [
  "Kratzer",
  "Delle",
  "Lackschaden",
  "Steinschlag",
  "Glasbruch",
  "Felgenschaden",
  "Innenraum",
  "Sonstiges",
];

export const DAMAGE_ZONES = [
  "Front",
  "Hinten",
  "Links",
  "Rechts",
  "Dach",
  "Innenraum",
];
